import { render, staticRenderFns } from "./LinkBooking.vue?vue&type=template&id=3911485f&scoped=true&"
import script from "./LinkBooking.vue?vue&type=script&lang=js&"
export * from "./LinkBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911485f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/portal-staging.usave.com/releases/78370861/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3911485f')) {
      api.createRecord('3911485f', component.options)
    } else {
      api.reload('3911485f', component.options)
    }
    module.hot.accept("./LinkBooking.vue?vue&type=template&id=3911485f&scoped=true&", function () {
      api.rerender('3911485f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/portal/components/bookings/LinkBooking.vue"
export default component.exports